<script lang="ts">
  import { onMount } from "svelte";
  import Header from "./Header.svelte";
  import Footer from "./Footer.svelte";
  import ContactForm from "./ContactForm.svelte";
  import { pageById } from "./pages";
  import { applyBehaviors } from "./behaviors";

  // Reuse the generated page metadata for title/description parity.
  const meta = pageById["kontakt"];

  let main: HTMLElement;
  let cleanup: (() => void) | null = null;

  onMount(() => {
    if (meta?.title) document.title = meta.title;
    let desc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.name = "description";
      document.head.appendChild(desc);
    }
    desc.content = meta?.description ?? "";
    window.scrollTo({ top: 0, behavior: "auto" });
    if (main) cleanup = applyBehaviors(main);
    return () => cleanup?.();
  });
</script>

<Header active="" />
<main bind:this={main}>
  <div class="wrap" style="padding-block:clamp(28px,4vw,44px) 0">
    <div class="crumb">
      <a href="/">Start</a><span class="sep">›</span><span class="here">Kontakt</span>
    </div>
  </div>
  <section class="section" style="padding-top:clamp(22px,3vw,34px)">
    <div class="wrap" style="max-width:880px">
      <span class="eyebrow">Kontakt</span>
      <h1 class="title" style="font-size:clamp(30px,4.2vw,50px); margin:14px 0 18px">
        Kontakt
      </h1>
      <div class="prose" style="max-width:none; margin-top:10px">
        <p>Fragen, Interesse oder Feedback? Schreib uns — wir melden uns.</p>
        <h2>Kontaktformular</h2>
        <ContactForm kind="contact" />
      </div>
    </div>
  </section>
</main>
<Footer />
